import { render } from "preact";
import { Router } from "preact-router";
import App from "./App";
import "./index.css";

render(
  <Router>
    <App path="/" />
  </Router>,
  document.getElementById("app")!
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}
